import React from 'react';

import { ModalContainer } from 'components/guardedModal/ModalContainer';
import { BlacklistConfirmationModalContentContainer } from './BlacklistConfirmationModalContentContainer';
import { SimpleModalId } from 'constants/modalId';

export const BlacklistConfirmationModal = () => {
  return (
    <ModalContainer id={SimpleModalId.ParticipantBlacklistConfirmation}>
      <BlacklistConfirmationModalContentContainer />
    </ModalContainer>
  );
};
